export default __webpack_public_path__ + "static/media/disabilities.e594f83b.svg";